export const fmtDateTime = (iso) => {
  if (!iso) return "-";
  try {
    const d = new Date(iso);
    return d.toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch { return iso; }
};

export const fmtDate = (iso) => {
  if (!iso) return "-";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric" });
  } catch { return iso; }
};

export const personName = (p) => {
  if (!p) return "-";
  const n = `${p.nome || ""} ${p.cognome || ""}`.trim();
  return n || p.ragione_sociale || "Senza nome";
};

export const initials = (p) => {
  const n = personName(p);
  return n.split(" ").filter(Boolean).slice(0, 2).map((s) => s[0]?.toUpperCase()).join("") || "?";
};

export const isOverdue = (t) => {
  if (!t?.data_scadenza) return false;
  if (!["Da fare", "In corso", "In attesa"].includes(t.stato)) return false;
  try { return new Date(t.data_scadenza) < new Date(); } catch { return false; }
};
